import type { Category, Listing, Stat, FooterColumn, TrustFeature, Tab } from '../types';
import { 
  Car, 
  Building2, 
  Smartphone, 
  Briefcase, 
  Bike, 
  Tv, 
  Shirt, 
  Sofa,
  LucideIcon
} from 'lucide-react';

export interface CategoryWithIcon extends Category {
  Icon: LucideIcon;
  gradient: string;
}

export const CATEGORIES: CategoryWithIcon[] = [
  { 
    icon: '🚗', 
    name: 'Cars & Vehicles', 
    count: '24,891', 
    color: '#EF4444',
    Icon: Car,
    gradient: 'from-red-500 to-rose-600'
  },
  { 
    icon: '🏠', 
    name: 'Property', 
    count: '18,432', 
    color: '#10B981',
    Icon: Building2,
    gradient: 'from-emerald-500 to-teal-600'
  },
  { 
    icon: '📱', 
    name: 'Mobiles', 
    count: '31,204', 
    color: '#8B5CF6',
    Icon: Smartphone,
    gradient: 'from-violet-500 to-purple-600'
  },
  { 
    icon: '💼', 
    name: 'Jobs', 
    count: '9,874', 
    color: '#F59E0B',
    Icon: Briefcase,
    gradient: 'from-amber-500 to-orange-600'
  },
  { 
    icon: '🏍️', 
    name: 'Bikes', 
    count: '12,543', 
    color: '#06B6D4',
    Icon: Bike,
    gradient: 'from-cyan-500 to-blue-600'
  },
  { 
    icon: '🖥️', 
    name: 'Electronics', 
    count: '22,109', 
    color: '#3B82F6',
    Icon: Tv,
    gradient: 'from-blue-500 to-indigo-600'
  },
  { 
    icon: '👗', 
    name: 'Fashion', 
    count: '15,782', 
    color: '#EC4899',
    Icon: Shirt,
    gradient: 'from-pink-500 to-rose-600'
  },
  { 
    icon: '🛋️', 
    name: 'Furniture', 
    count: '8,321', 
    color: '#F97316',
    Icon: Sofa,
    gradient: 'from-orange-500 to-amber-600'
  },
];

export const LISTINGS: Listing[] = [
  { id: 1, title: 'Toyota Corolla GLi 2021', price: 'PKR 52,00,000', location: 'Lahore, Punjab', time: '2 hours ago', badge: 'Verified', tag: 'Cars', img: 'https://picsum.photos/seed/listing-car-1/900/600', color: '#FFF3EE', featured: true, year: 2021, mileage: 35000, fuelType: 'Petrol', transmission: 'Automatic' },
  { id: 2, title: 'Honda Civic Oriel 2020', price: 'PKR 68,50,000', location: 'Karachi, Sindh', time: '3 hours ago', badge: 'Hot Deal', tag: 'Cars', img: 'https://picsum.photos/seed/listing-car-2/900/600', color: '#FFF3EE', featured: true, year: 2020, mileage: 48000, fuelType: 'Petrol', transmission: 'Automatic' },
  { id: 3, title: 'Suzuki Alto VXR 2022', price: 'PKR 31,20,000', location: 'Islamabad', time: '5 hours ago', badge: 'New', tag: 'Cars', img: 'https://picsum.photos/seed/listing-car-3/900/600', color: '#FFF3EE', featured: false, year: 2022, mileage: 15000, fuelType: 'Petrol', transmission: 'Manual' },
  { id: 4, title: 'KIA Sportage AWD 2021', price: 'PKR 92,00,000', location: 'Multan', time: '7 hours ago', badge: 'Urgent', tag: 'Cars', img: 'https://picsum.photos/seed/listing-car-4/900/600', color: '#FFF3EE', featured: false, year: 2021, mileage: 28000, fuelType: 'Petrol', transmission: 'Automatic' },
  { id: 5, title: '5 Marla House in Bahria Town', price: 'PKR 1,85,00,000', location: 'Lahore, Punjab', time: '1 hour ago', badge: 'Verified', tag: 'Property', img: 'https://picsum.photos/seed/listing-property-1/900/600', color: '#F0FFFE', featured: true },
  { id: 6, title: '3 Bed Apartment DHA Phase 6', price: 'PKR 2,20,00,000', location: 'Karachi, Sindh', time: '4 hours ago', badge: 'Hot Deal', tag: 'Property', img: 'https://picsum.photos/seed/listing-property-2/900/600', color: '#F0FFFE', featured: true },
  { id: 7, title: '10 Marla Plot in Gulberg', price: 'PKR 1,35,00,000', location: 'Faisalabad', time: '6 hours ago', badge: 'New', tag: 'Property', img: 'https://picsum.photos/seed/listing-property-3/900/600', color: '#F0FFFE', featured: false },
  { id: 8, title: 'Farmhouse Near Islamabad Expressway', price: 'PKR 4,90,00,000', location: 'Islamabad', time: '9 hours ago', badge: 'Urgent', tag: 'Property', img: 'https://picsum.photos/seed/listing-property-4/900/600', color: '#F0FFFE', featured: false },
  { id: 9, title: 'iPhone 15 Pro Max 256GB', price: 'PKR 3,85,000', location: 'Islamabad', time: '1 hour ago', badge: 'New', tag: 'Mobiles', img: 'https://picsum.photos/seed/listing-mobile-1/900/600', color: '#F5F3FF', featured: true },
  { id: 10, title: 'Samsung Galaxy S24 Ultra', price: 'PKR 3,25,000', location: 'Lahore, Punjab', time: '2 hours ago', badge: 'Verified', tag: 'Mobiles', img: 'https://picsum.photos/seed/listing-mobile-2/900/600', color: '#F5F3FF', featured: false },
  { id: 11, title: 'Google Pixel 8 Pro PTA Approved', price: 'PKR 2,20,000', location: 'Rawalpindi', time: '5 hours ago', badge: 'Hot Deal', tag: 'Mobiles', img: 'https://picsum.photos/seed/listing-mobile-3/900/600', color: '#F5F3FF', featured: false },
  { id: 12, title: 'OnePlus 12 16/512', price: 'PKR 2,35,000', location: 'Karachi, Sindh', time: '8 hours ago', badge: 'Urgent', tag: 'Mobiles', img: 'https://picsum.photos/seed/listing-mobile-4/900/600', color: '#F5F3FF', featured: false },
  { id: 13, title: 'Senior React Developer – Remote', price: 'PKR 2,00,000/mo', location: 'Remote – Pakistan', time: '30 min ago', badge: 'Urgent', tag: 'Jobs', img: 'https://picsum.photos/seed/listing-job-1/900/600', color: '#FFFBEB', featured: true },
  { id: 14, title: 'Accountant Needed for Textile Firm', price: 'PKR 95,000/mo', location: 'Faisalabad', time: '2 hours ago', badge: 'New', tag: 'Jobs', img: 'https://picsum.photos/seed/listing-job-2/900/600', color: '#FFFBEB', featured: false },
  { id: 15, title: 'Sales Executive for Real Estate', price: 'PKR 80,000 + Commission', location: 'Lahore, Punjab', time: '4 hours ago', badge: 'Verified', tag: 'Jobs', img: 'https://picsum.photos/seed/listing-job-3/900/600', color: '#FFFBEB', featured: false },
  { id: 16, title: 'UI/UX Designer (Onsite)', price: 'PKR 1,40,000/mo', location: 'Karachi, Sindh', time: '7 hours ago', badge: 'Hot Deal', tag: 'Jobs', img: 'https://picsum.photos/seed/listing-job-4/900/600', color: '#FFFBEB', featured: false },
  { id: 17, title: 'Honda CB150F 2023', price: 'PKR 3,45,000', location: 'Faisalabad', time: '3 hours ago', badge: 'Verified', tag: 'Bikes', img: 'https://picsum.photos/seed/listing-bike-1/900/600', color: '#F0FDF4', featured: true },
  { id: 18, title: 'Yamaha YBR 125 2022', price: 'PKR 4,20,000', location: 'Lahore, Punjab', time: '5 hours ago', badge: 'New', tag: 'Bikes', img: 'https://picsum.photos/seed/listing-bike-2/900/600', color: '#F0FDF4', featured: false },
  { id: 19, title: 'Suzuki GS150 Special Edition', price: 'PKR 3,60,000', location: 'Karachi, Sindh', time: '6 hours ago', badge: 'Hot Deal', tag: 'Bikes', img: 'https://picsum.photos/seed/listing-bike-3/900/600', color: '#F0FDF4', featured: false },
  { id: 20, title: 'United 70 CC 2024', price: 'PKR 1,55,000', location: 'Multan', time: '10 hours ago', badge: 'Urgent', tag: 'Bikes', img: 'https://picsum.photos/seed/listing-bike-4/900/600', color: '#F0FDF4', featured: false },
  { id: 21, title: 'Samsung 55" QLED 4K Smart TV', price: 'PKR 1,75,000', location: 'Rawalpindi', time: '4 hours ago', badge: 'New', tag: 'Electronics', img: 'https://picsum.photos/seed/listing-electronics-1/900/600', color: '#EFF6FF', featured: true },
  { id: 22, title: 'Dell XPS 13 i7 16GB', price: 'PKR 3,10,000', location: 'Islamabad', time: '5 hours ago', badge: 'Verified', tag: 'Electronics', img: 'https://picsum.photos/seed/listing-electronics-2/900/600', color: '#EFF6FF', featured: false },
  { id: 23, title: 'Sony PlayStation 5 Disc Edition', price: 'PKR 1,65,000', location: 'Lahore, Punjab', time: '8 hours ago', badge: 'Hot Deal', tag: 'Electronics', img: 'https://picsum.photos/seed/listing-electronics-3/900/600', color: '#EFF6FF', featured: false },
  { id: 24, title: 'Canon EOS M50 Mark II Kit', price: 'PKR 1,95,000', location: 'Karachi, Sindh', time: '12 hours ago', badge: 'Urgent', tag: 'Electronics', img: 'https://picsum.photos/seed/listing-electronics-4/900/600', color: '#EFF6FF', featured: false },
  { id: 25, title: 'Luxury Lawn 3-Piece Suit', price: 'PKR 8,500', location: 'Karachi, Sindh', time: '2 hours ago', badge: 'New', tag: 'Fashion', img: 'https://picsum.photos/seed/listing-fashion-1/900/600', color: '#FFF1F7', featured: true },
  { id: 26, title: 'Men Formal Blazer Imported', price: 'PKR 14,000', location: 'Lahore, Punjab', time: '6 hours ago', badge: 'Verified', tag: 'Fashion', img: 'https://picsum.photos/seed/listing-fashion-2/900/600', color: '#FFF1F7', featured: false },
  { id: 27, title: 'Bridal Maxi Hand Embroidered', price: 'PKR 48,000', location: 'Faisalabad', time: '9 hours ago', badge: 'Hot Deal', tag: 'Fashion', img: 'https://picsum.photos/seed/listing-fashion-3/900/600', color: '#FFF1F7', featured: false },
  { id: 28, title: 'Sneakers Unisex Imported', price: 'PKR 11,500', location: 'Islamabad', time: '14 hours ago', badge: 'Urgent', tag: 'Fashion', img: 'https://picsum.photos/seed/listing-fashion-4/900/600', color: '#FFF1F7', featured: false },
  { id: 29, title: '6 Seater Wooden Dining Table', price: 'PKR 85,000', location: 'Rawalpindi', time: '1 hour ago', badge: 'Verified', tag: 'Furniture', img: 'https://picsum.photos/seed/listing-furniture-1/900/600', color: '#FFF7ED', featured: true },
  { id: 30, title: 'Modern L Shape Sofa Set', price: 'PKR 1,25,000', location: 'Lahore, Punjab', time: '4 hours ago', badge: 'New', tag: 'Furniture', img: 'https://picsum.photos/seed/listing-furniture-2/900/600', color: '#FFF7ED', featured: false },
  { id: 31, title: 'Office Ergonomic Chair Mesh', price: 'PKR 29,500', location: 'Karachi, Sindh', time: '8 hours ago', badge: 'Hot Deal', tag: 'Furniture', img: 'https://picsum.photos/seed/listing-furniture-3/900/600', color: '#FFF7ED', featured: false },
  { id: 32, title: 'Queen Size Bed with Side Tables', price: 'PKR 72,000', location: 'Multan', time: '11 hours ago', badge: 'Urgent', tag: 'Furniture', img: 'https://picsum.photos/seed/listing-furniture-4/900/600', color: '#FFF7ED', featured: false },
];

export const STATS: Stat[] = [
  { number: '2,400+', label: 'Listings'   },
  { number: '850+', label: 'Users'        },
  { number: '20+',  label: 'Cities'     },
  { number: '4.8',   label: 'User Rating'  },
];

export const TRUST_FEATURES: TrustFeature[] = [
  { icon: '🔒', title: 'Verified Listings',  desc: 'Listings checked for accuracy'     },
  { icon: '🔍', title: 'Easy Search',      desc: 'Find what you need quickly'     },
  { icon: '💬', title: 'Direct Chat',  desc: 'Contact sellers instantly'                  },
  { icon: '🛡️', title: 'Safety First',      desc: 'Report suspicious listings'       },
];

export const FOOTER_COLUMNS: FooterColumn[] = [
  { title: 'Categories', links: ['Cars & Vehicles', 'Property', 'Mobiles', 'Jobs', 'Bikes']                },
  { title: 'Company',    links: ['About Us', 'Blog', 'Careers', 'Press', 'Contact']             },
  { title: 'Support',    links: ['Help Center', 'Safety Tips', 'Report Ad', 'Terms', 'Privacy'] },
];

export const TABS: Tab[] = ['All', 'Cars & Vehicles', 'Property', 'Mobiles', 'Jobs', 'Bikes'];

export const QUICK_TAGS: string[] = [
  'Toyota Corolla', '1 Kanal Plot', 'iPhone 15', 'React Developer', 'Honda CD70',
];

export const CITIES: string[] = [
  'All Pakistan', 'Lahore', 'Karachi', 'Islamabad',
  'Faisalabad', 'Rawalpindi', 'Multan', 'Peshawar',
];
